// Layout Types
export const LAYOUT_ANALYTICS_TYPES = { DEFAULT: 'default', MENTIONS: 'mentions' } as const;
export type LayoutAnalyticsType =
    (typeof LAYOUT_ANALYTICS_TYPES)[keyof typeof LAYOUT_ANALYTICS_TYPES];

// Datepicker local storage data
export const localStorageDatepickerAnalytics = 'ico-datepicker-analytics';
export const localStorageDatepickerMentions = 'ico-datepicker-mentions';
export const localStorageDatepickers = {
    [LAYOUT_ANALYTICS_TYPES.DEFAULT]: localStorageDatepickerAnalytics,
    [LAYOUT_ANALYTICS_TYPES.MENTIONS]: localStorageDatepickerMentions
};
